import React from 'react';
import {
    PanelHeader,
    Div,
    Title,
    SplitCol,
    SplitLayout,
    Button, ButtonGroup, Cell, Avatar, Chip, ModalRoot, ModalPage, ModalPageHeader, PanelHeaderButton
} from '@vkontakte/vkui';
import axios from "axios";

import {
    Icon16Clear, Icon24BrowserBack,
    Icon24Info, Icon24PicturePlusOutline, Icon24Story, Icon28Camera, Icon28PicturePlusOutline
} from "@vkontakte/icons";
import IncomingProducts from "./IncomingProducts";
import {AdaptivityContext, getGUID, photo_incomings_key, setQuizStep} from "../assets/constants";
import Fancybox from "../assets/fancybox";
import moment from "moment";
import * as constants from "../assets/constants";
import IncomingDocsViewer from "./IncomingDocsViewer";
import IncomingStepHeader from "./StepHeader";


class IncomingStep2 extends React.Component {

    state = {
        items_monitoring: {},
        loading: true,
        modalHistory: []
    }
    constructor(props) {
        super(props);
    }


    loadImages = () => {
        const data = localStorage.getItem(constants.photo_incomings_key)
        if (data && data !== "undefined") {
            const items = JSON.parse(data)
            this.setState({items_monitoring: items})
        } else {
            this.setState({items_monitoring: {}})
        }
    }

    componentDidMount() {
        this.loadImages()
        window.addEventListener("message", this.receiveMessage, false)

    }

    componentWillUnmount = () => {
        localStorage.setItem(constants.photo_incomings_key, JSON.stringify(this.state.items_monitoring ? this.state.items_monitoring : {}))
        window.removeEventListener("message", this.receiveMessage)

    }
    clearPhoto = (num = 0) => {
        let items = this.state.items_monitoring ? this.state.items_monitoring : {}

        if (items[num] != undefined) {
            delete items[num]
        }
        this.setState({items_monitoring: items})

        localStorage.setItem(constants.photo_incomings_key, JSON.stringify(items))
    }

    getPhoto = (num = 0) => {
        if (this.props.father) {
            this.props.father.setState({
                activePanelIncoming: 'incoming_photo_panel',
                lastIncomingPanel: this.props.father.state.activePanelIncoming,
                IncomingImageEventName: "setIncomingImage",
                numIncomingImage: num,
            })
        }
    }

    receiveMessage = (event) => {

        if (event.data.type != undefined && event.data.type == 'reloadIncomingImages') {
            this.loadImages()
        }
        if (event.data == 'incomingGoGetBack') {
             setQuizStep(1, 'Incoming')
        }
    }


    render() {
        const images_url = this.props.base_url.replace("frontend/", '');
        const monitoring_photo = this.state.items_monitoring && this.state.items_monitoring[0] ? this.state.items_monitoring[0] : {
            hasImage: false
        }
        const cnt = Object.keys(this.state.items_monitoring).length
        function nextStep(){
            let errors =0
            if(!monitoring_photo.hasImage){
                errors++
                window.postMessage({type:"error", "text":'Необходимо сделать фото автомобиля с госномером'})
            }
            if(errors ==0){
                setQuizStep(3, 'Incoming')
            }
        }



        return (
            <SplitLayout  >
                <SplitCol>
                    <PanelHeader fixed={true}>
                        <Div>
                            Приемка. Шаг 2
                        </Div>
                    </PanelHeader>
                    <IncomingStepHeader currentDocs={this.props.currentDocs}  step={2} />
                    <SplitLayout>
                        <SplitCol>
                            <Div>
                                <Title>
                                    Сделайте фото
                                </Title>
                            </Div>
                            <Cell before="Фото машины с номером" multiline={true}
                                  after={<Fancybox key={'IncomingMonitoringFancyBox'+getGUID()}>
                                      <div className="sale-doc-form_monitoring-avatar">
                                          {monitoring_photo.hasImage ?

                                              [<a data-fancybox={'galleryIncoming1'}
                                                  href={images_url + monitoring_photo.mainImage.replace(images_url, '')}>
                                                  {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                           size={AdaptivityContext.isMobile ? 100 : 260}
                                                           src={monitoring_photo.thumb}/>}
                                              </a>, <Cell before={<Chip
                                                  removable={false}>Дата</Chip>}>{moment(monitoring_photo.date).format('DD.MM.YYYY')}</Cell>]
                                              :
                                              <Avatar mode="image" style={{borderRadius: '5%'}}
                                                      onClick={() => this.getPhoto()}
                                                      size={AdaptivityContext.isMobile ? 100 : 260}
                                                      src={images_url + constants.EMPTY_IMG}/>
                                          }
                                      </div>
                                  </Fancybox>}></Cell>
                            <Div>
                                <Title>Произвольные фото</Title>
                            </Div>
                            <Div className="incoming-photos-gallery">
                                <Fancybox key={'IncomingMonitoringFancyBox'+getGUID()}>
                                    {cnt > 0 ? <div className="main-catalog_product-wrapper_avatar"
                                                    style={{width: AdaptivityContext.isMobile ? '108px' : '268px'}}>
                                        <Button mode="secondary"
                                                onClick={() => this.getPhoto(cnt + 1)}
                                                style={{width: "100px"}}><Icon28PicturePlusOutline
                                            height={100}/></Button>
                                    </div> : ''}
                                    {Object.keys(this.state.items_monitoring).map((key, index) => {
                                        if (index == 0) return ''
                                        const item = this.state.items_monitoring[key]
                                        return (
                                            <div className="main-catalog_product-wrapper_avatar"
                                                 style={{width: AdaptivityContext.isMobile ? '108px' : '268px'}}>
                                                {item.hasImage ?

                                                    [<a data-fancybox={'galleryIncoming2'}
                                                        href={images_url + item.mainImage.replace('https:/l', 'https://l').replace(images_url, '')}>
                                                        {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                                 size={AdaptivityContext.isMobile ? 100 : 260}
                                                                 src={item.thumb}/>}
                                                    </a>,
                                                        <ButtonGroup stretched>
                                                            <Button mode="outline" stretched size="s"
                                                                    onClick={() => {
                                                                        this.getPhoto(key)
                                                                    }}><Icon24Story/></Button>
                                                            <Button mode="outline" stretched size="s"
                                                                    onClick={() => {
                                                                        this.clearPhoto(key)
                                                                    }}><Icon16Clear/></Button>
                                                        </ButtonGroup>]
                                                    :
                                                    <Avatar mode="image" style={{borderRadius: '5%'}}
                                                            onClick={() => {
                                                                this.getPhoto(key)
                                                            }}
                                                            size={AdaptivityContext.isMobile ? 100 : 260}
                                                            src={images_url + constants.EMPTY_IMG}/>
                                                }
                                            </div>
                                        )

                                    })}
                                </Fancybox>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout>
                        <SplitCol>
                            <Div className="action-board">
                                <ButtonGroup mode="horizontal" stretched>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => setQuizStep(1, 'Incoming')}>Назад</Button>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => nextStep()}>Далее</Button>
                                </ButtonGroup>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                </SplitCol>
            </SplitLayout>)
    }


}

export default IncomingStep2